import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { IValidationHandler, TValidator } from '../../model';

export function patternValidator(args: IValidationHandler): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const { value, invalid } = control;

    if (invalid) return null;

    if (!value) return null;

    const matchPattern = value.match(args.pattern);

    if (!matchPattern?.length) {
      const { type } = args;
      return {
        [type as TValidator]: value
      };
      // const vldResponse: TValidatorError = { pattern: value };
      // return vldResponse;
    }

    return null;
  };
}
